import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-body pt-3 card-body pt-3 border border-dashed border-gray-300 card-rounded bg-light-warning"
}
const _hoisted_2 = { class: "mb-1" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  key: 0,
  class: ""
}
const _hoisted_5 = {
  key: 1,
  class: ""
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Ứng viên", -1)
const _hoisted_7 = {
  key: 0,
  class: "d-flex mb-1"
}
const _hoisted_8 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    (_ctx.dataCustomer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, "Ngày tạo ứng viên: " + _toDisplayString(_ctx.dataCustomer.createdAt), 1),
            (_ctx.dataCustomer.lastModifiedBy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode("Sửa lần cuối bởi: "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.dataCustomer.lastModifiedBy.split('_')[0]), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode("Sửa lần cuối bởi: "),
                  _hoisted_6
                ]))
          ]),
          (_ctx.dataCustomer.updatedAt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, "Ngày sửa: " + _toDisplayString(_ctx.dataCustomer.updatedAt), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}